import React from "react";
import {styled} from "@mui/material/styles";
import {Box, Grid, Typography} from "@mui/material";
import Header from "../../Header";
import VerificationPage from "./VerificationPage";
import {useLocation} from "react-router";

const Content = styled("div")(({theme}) => ({
  flexGrow: 1,
  paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // Add margin top here
  // marginTop: theme.spacing(10), // Adjust the spacing as needed
}));

function VerifyInsuree() {
  const {state} = useLocation();
  console.log("verificationProps", state);
  return (
    <Box>
      {/* <Grid container> */}
      <Header>
         <Content>
            <VerificationPage insureeData={state}/>
          </Content>
      </Header>
    </Box>
  );
}

export default VerifyInsuree;
